import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {styled} from "@mui/material/styles";
import {ICharPresets} from "../../_interfaces/ICharPresets";
import {useSignals} from "@preact/signals-react/runtime";
import {v4} from "uuid";
import CharCreate from "../../_helper/charcreate";
import {s_char_presets, s_char_skills, s_char_talents, s_char_weapons} from "../../_signals/s_char";
import {PresetsCreate, PresetsUpdate} from "../../_api/BEPresets";
import {s_char_attr_step} from "../../_signals/s_char_attr";

const Item = styled('div')(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff', ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.secondary,
}));

interface IProp {
    edit: ICharPresets | null
    add: boolean
    isOpen: (open: boolean) => void
    updateCurrent: (data: ICharPresets | null) => void
}

export default function PresetsEdit({edit, add, isOpen, updateCurrent}: IProp) {
    useSignals()

    const strain_values = [...Array(11).keys()];
    const step_values = [...Array(16).keys()];

    const titleRef = useRef<HTMLInputElement>(null);
    const descrRef = useRef<HTMLInputElement>(null);

    const [current, setCurrent] = useState<null | ICharPresets>(null)

    useEffect(() => {
        console.log('effect', edit)
        if (edit) setCurrent(edit)
    }, [edit])

    const save = () => {
        if (!current) return;

        current.title = titleRef.current?.value ?? current.title;
        current.descr = descrRef.current?.value ?? current.descr;

        if (add) {
            PresetsCreate(current)
            s_char_presets.value = [...s_char_presets.value, current]
        } else {
            PresetsUpdate(current)
            s_char_presets.value = s_char_presets.value.map(p => {
                if (p.id === current.id) return current
                return p
            })
        }
        updateCurrent(current)

        isOpen(false)
    }

    const change = (field: string, value: string) => {

        // set?
        //     step: number,
        //     fix_mod: number,
        //     roll_mod: number,
        //     strain: number,
        //     karma: boolean,
        console.log({'current': current, 'field': field, 'value': value})
        if (!current) return
        switch (field) {
            case 'weapon':
                if (value === 'none') {
                    setCurrent({...current, weapon: '',})
                } else {
                    const weapon = s_char_weapons.value.find(w => w.id == value)
                    if (weapon) {
                        setCurrent({
                            ...current,
                            weapon: value,
                            attribute: weapon.attribute,
                            step: weapon.dmg + weapon.dmg_mod,
                        })
                    }
                }
                break
            case 'talent':
                if (value === 'none') {
                    setCurrent({...current, talent: ''})
                } else {
                    const talent = s_char_talents.value.find(w => w.id == value)
                    if (talent) {
                        setCurrent({
                            ...current,
                            skill:'',
                            talent: value,
                            attribute: talent.attribute,
                            step: talent.step,
                            strain: talent.strain,
                        })
                    }
                }
                break
            case 'skill':
                if (value === 'none') {
                    setCurrent({...current, skill: ''})
                } else {
                    const skill = s_char_skills.value.find(w => w.id == value)
                    if (skill) {
                        setCurrent({
                            ...current,
                            talent:'',
                            skill: value,
                            attribute: skill.attribute,
                            step: skill.step,
                            strain:skill.strain,
                        })
                    }
                }
                break
            case 'attribute':
                if (value === 'none') {
                    setCurrent({...current, attribute: ''})
                } else {
                    const step = s_char_attr_step(value).value
                    setCurrent({
                        ...current,
                        attribute: value,
                        step: step,
                    })
                }
        }
    }

    return <Dialog open={!!edit}>

        <DialogContent>
            <Grid container>
                <Grid item xs={12}>
                    <Item>
                        <TextField
                            style={{width: '100%'}}
                            defaultValue={current?.title || ""}
                            inputRef={titleRef}
                            type="text"
                            label={'Bezeichnung'}
                            variant="standard"/>
                    </Item>
                </Grid>

                <Grid item xs={12}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-sonst-weapon-label">Waffe</InputLabel>
                            <Select value={current?.weapon || ''}
                                    labelId="dialog-sonst-weapon-label"
                                    variant="standard"
                            >
                                <MenuItem key={'dialog-weapon-remove'} value={'none'}
                                          onClick={() => change('weapon', 'none')}>
                                    -keine-
                                </MenuItem>
                                {s_char_weapons.value.map(a =>
                                    <MenuItem key={a.id} value={a.id}
                                              onClick={() => change('weapon', a.id)}>
                                        {a.name}
                                    </MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>

                <Grid item xs={12}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-talent-label">Talent</InputLabel>
                            <Select value={current?.talent || ''}
                                    labelId="dialog-talent-label"
                                    variant="standard"
                            >
                                <MenuItem key={'dialog-talent-remove'} value={'none'}
                                          onClick={() => change('talent', 'none')}>
                                    -keines-
                                </MenuItem>
                                {s_char_talents.value.map(a =>
                                    <MenuItem key={a.id}
                                              value={a.id}
                                              onClick={(e) => change('talent', a.id)}>
                                        {a.name} {a.discipline}
                                    </MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>

                <Grid item xs={12}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-skill-label">Fertigkeit</InputLabel>
                            <Select value={current?.skill || ''}
                                    labelId="dialog-skill-label"
                                    variant="standard"
                            >
                                <MenuItem key={'dialog-skill-remove'} value={'none'}
                                          onClick={() => change('skill', 'none')}>
                                    -keines-
                                </MenuItem>
                                {s_char_skills.value.map(a =>
                                    <MenuItem key={a.id}
                                              value={a.id}
                                              onClick={(e) => change('skill', a.id)}>
                                        {a.name}
                                    </MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>

                <Grid item xs={12}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-attribute-label">Attribut</InputLabel>
                            <Select value={current?.attribute || ''}
                                    labelId="dialog-attribute-label"
                                    variant="standard"
                                    renderValue={(selected) => {
                                        return CharCreate.attributes.filter(a => a.pfield === selected.toString()).shift()?.tt;
                                    }}
                            >
                                {CharCreate.attributes.map(a =>
                                    <MenuItem key={v4()}
                                              value={a.pfield}
                                              onClick={(e) => change('attribute', a.pfield)}>
                                        {a.tt}
                                    </MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>

                <Grid item xs={4}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-sonst-step-label">Stufe</InputLabel>
                            <Select value={current?.step || 0}
                                    onChange={(e) => {
                                        if (current) setCurrent({...current, step: e.target.value as number});
                                    }}
                                    labelId="dialog-sonst-step-label"
                                    variant="standard"
                            >
                                {step_values.map(val => <MenuItem key={v4()}
                                                                  value={val}>{val>0?val:'berechnet'}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>
                <Grid item xs={4}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-sonst-mod-label">Modifikator</InputLabel>
                            <Select value={current?.fix_mod || 0}
                                    onChange={(e) => {
                                        if (current) setCurrent({...current, fix_mod: e.target.value as number});
                                    }}
                                    labelId="dialog-sonst-mod-label"
                                    variant="standard"
                            >
                                {step_values.map(val => <MenuItem key={v4()}
                                                                  value={val}>{val}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>


                <Grid item xs={4}>
                    <Item>
                        <FormControl variant="standard" style={{width: '100%'}}>
                            <InputLabel id="dialog-sonst-strain-label">Überanstrengung</InputLabel>
                            <Select value={current?.strain || 0}
                                    onChange={(event) => {
                                        if (current) setCurrent({...current, strain: event.target.value as number});
                                    }}
                                    labelId="dialog-sonst-strain-label"
                                    variant="standard"
                            >
                                {strain_values.map(val => <MenuItem key={v4()} value={val}>{val}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Item>
                </Grid>
                <Grid item xs={6}>
                    <Item>
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            label="Karma möglich?"
                            control={<Checkbox
                                defaultChecked={current?.karma||false}
                                onClick={() => {
                                    if (current) setCurrent({...current, karma: !current.karma});
                                }}/>}/>
                    </Item>
                </Grid>
                <Grid item xs={6}>
                    <Item>
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            label="Inititive?"
                            control={<Checkbox
                                defaultChecked={current?.rollas === 'ini'||false}
                                onClick={() => {
                                    if (current) setCurrent({
                                        ...current,
                                        rollas: current?.rollas === 'ini' ? '' : 'ini'
                                    });
                                }}/>}/>
                    </Item>
                </Grid>
                <Grid item xs={6}>
                    <Item>
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            label="Trefferwurf?"
                            control={<Checkbox
                                defaultChecked={current?.rollas === 'hit'||false}
                                onClick={() => {
                                    if (current) setCurrent({
                                        ...current,
                                        rollas: current?.rollas === 'hit' ? '' : 'hit'
                                    });
                                }}/>}/>
                    </Item>
                </Grid>
                <Grid item xs={6}>
                    <Item>
                        <FormControlLabel
                            style={{marginLeft: 0}}
                            label="Schaden?"
                            control={<Checkbox
                                defaultChecked={current?.rollas === 'dmg'||false}
                                onClick={() => {
                                    if (current) setCurrent({
                                        ...current,
                                        rollas: current?.rollas === 'dmg' ? '' : 'dmg'
                                    });
                                }}/>}/>
                    </Item>
                </Grid>
                <Grid item xs={12}>
                    <Item>
                        <TextField
                            style={{width: '100%', backgroundColor: "white", maxHeight: 48}}
                            inputProps={{
                                style: {backgroundColor: "white", maxHeight: 48},
                            }}
                            InputProps={{
                                style: {backgroundColor: "white", maxHeight: 48},
                            }}
                            defaultValue={current?.descr || ""}
                            inputRef={descrRef}
                            type="text"
                            label={'Beschreibung'}
                            variant="filled"/>
                    </Item>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => isOpen(false)}>abbruch</Button>
            <Button onClick={() => save()}>
                <div>{add ? 'Add' : 'Save'}</div>
            </Button>
        </DialogActions>
    </Dialog>

}